import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../../commons/DataTable';
import ActionsField from './ActionsField';

function SignalsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  checkVatCode,
  onUpdateSignal,
  searchSignalmens,
  searchCondos,
  searchAdmins,
  signalTypes,
  handleFileListView,
  deleteFileConfirm,
}) {
  const [t] = useTranslation('SIGNALS');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field
        title="Segnalatore"
        source="signalman.businessName"
        className="text-left"
      />
      <Field
        title="Segnalatore P.iva/Codice Fiscale"
        source="signalman.taxCode"
        className="text-left"
      />
      <Field
        title="Beneficiario"
        source="adminInfo.businessName"
        className="text-left"
      />
      <Field
        title="Beneficiario P.iva/Codice Fiscale"
        source="adminInfo.taxCode"
        className="text-left"
      />
      <Field
        title="Nome Condominio"
        source="condoInfo.name"
        className="text-left"
      />
      <Field
        title="P.iva Condominio"
        source="condoInfo.vatCode"
        className="text-left"
      />
      <DateTimeField
        title="Data rendicontazione"
        source="accountabilityDate"
        className="text-left"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Totale fattura"
        source="estimate"
        className="txt-table-right"
      />
      <PercentageField
        title="Quota segnalatore %"
        source="signalmanSharePerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota segnalatore"
        source="signalmanShare"
        className="txt-table-right"
      />
      <PercentageField
        title="Quota extra %"
        source="extraPercentage"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota extra"
        source="extraShare"
        className="txt-table-right"
      />

      <Field
        title="Responsabile di zona"
        source="commercial.name"
        className="text-left"
      />
      <PercentageField
        title="Quota responsabile di zona %"
        source="commercial.perc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota responsabile di zona"
        source="commercial.share"
        className="txt-table-right"
      />

      <Field
        title="Commerciale 1"
        source="commercial2.name"
        className="text-left"
      />
      <PercentageField
        title="Quota commerciale 1 %"
        source="commercial2.perc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota commerciale 1"
        source="commercial2.share"
        className="txt-table-right"
      />

      <Field
        title="Commerciale 2"
        source="commercial3.name"
        className="text-left"
      />
      <PercentageField
        title="Quota commerciale 2 %"
        source="commercial3.perc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota commerciale 2"
        source="commercial3.share"
        className="txt-table-right"
      />
      <CurrencyField
        title="Totale da fatturare"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <Field
        title="Allegato"
        source="file.name"
        className="text-left"
        style={{
          minWidth: '200px',
          maxWidth: '300px',
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
        }}
      />
      <Field
        title="Note"
        source="notes"
        className="text-left"
        style={{
          minWidth: '200px',
          maxWidth: '300px',
          whiteSpace: 'normal',
          overflowWrap: 'break-word',
        }}
      />
      <ActionsField
        title="Azioni"
        data={data}
        checkVatCode={checkVatCode}
        onUpdateSignal={onUpdateSignal}
        searchSignalmens={searchSignalmens}
        searchCondos={searchCondos}
        searchAdmins={searchAdmins}
        signalTypes={signalTypes}
        handleFileListView={handleFileListView}
        deleteFileConfirm={deleteFileConfirm}
      />
    </DataTable>
  );
}

export default SignalsTable;
